module.exports = __webpack_public_path__ + "static/media/carrierMonitoringService.844fbcc9.jpg";